/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { VoiceAiScreenerResultAnswerDto } from './VoiceAiScreenerResultAnswerDto';

export type VoiceAiScreenerResultDto = {
    completed: boolean;
    status?: string;
    outcome?: VoiceAiScreenerResultDto.outcome;
    endReason?: string;
    answers?: Array<VoiceAiScreenerResultAnswerDto>;
    callSid?: string;
    phoneSessionId?: string;
    completedAt?: string;
}

export namespace VoiceAiScreenerResultDto {

    export enum outcome {
        COMPLETED = 'completed',
        DISCONNECTED = 'disconnected',
        SILENCE = 'silence',
        FAILED = 'failed',
    }


}
